import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnInit {

  message:string = "";
  
  constructor(@Inject(MAT_DIALOG_DATA) private data: { message: string}) { 
    if ( data.message != ""){
      this.message = data.message;
    }
  }

  ngOnInit() {}

}
